import { DatePeriodType, MeteringType, AnalyzeSettingsType, DateIntervalType } from '@enums';

export class AnalyzeFilterExportSettings {
  energySelected: boolean;
  flowSelected: boolean;
  effectSelected: boolean;
  normalEnergySelected: boolean; // Checkbox
  statusSelected: boolean;
  outdoorTempSelected: boolean;
  supplyTempSelected: boolean;
  returnTempSelected: boolean;
  humiditySelected: boolean;
  normalAdjustedSelected: boolean; // Radiobutton
  dateFrom?: Date;
  dateTo?: Date;
  period: DatePeriodType;
  compareYears: number[];
  meteringType: MeteringType;
  settingsType: AnalyzeSettingsType;
  meteringPointIds: number[];
  monthInterval: DateIntervalType;
  dayInterval: DateIntervalType;
  hourInterval: DateIntervalType;

  public static initalState = (): AnalyzeFilterExportSettings => {
    return <AnalyzeFilterExportSettings>{
      energySelected: false,
      flowSelected: false,
      effectSelected: false,
      normalEnergySelected: false,
      statusSelected: false,
      outdoorTempSelected: false,
      supplyTempSelected: false,
      returnTempSelected: false,
      humiditySelected: false,
      normalAdjustedSelected: false,
      period: DatePeriodType.Month,
      dateFrom: null,
      dateTo: null,
      compareYears: [],
      meteringPointIds: [],
      monthInterval: DateIntervalType.ThisYear,
      dayInterval: DateIntervalType.OneMonth,
      hourInterval: DateIntervalType.OneWeek
    };
  };
}
